import useSWR from 'swr';
import { checkExpiryDate, transformExtraPromotion } from '../helpers';
import { magentoService } from '../services';
import { ExtraPromotion } from '../types';

export const useVnpayPromotion = (vnPayPromotionCode: string) => {
  const { data, error } = useSWR(
    [`/magento/customdata/${vnPayPromotionCode}`, vnPayPromotionCode],
    (_url, code) =>
      magentoService.getCustomData(code).then((res) =>
        Object.values((res.data?.data as ExtraPromotion) || {})
          .map((promotion) => transformExtraPromotion(promotion))
          .filter(
            (promotion) =>
              promotion.date &&
              checkExpiryDate(promotion.date.startDate, promotion.date.endDate),
          ),
      ),
    {
      revalidateOnFocus: false,
    },
  );

  return {
    vnpayPromotions: data || [],
    loading: !data && !error,
  };
};
